import { CommonLayout } from '../commonComponents';
import {
    Route,
    Switch,
    useRouteMatch
} from 'react-router-dom';
import MutualFundResearch from './mutualFundResearch';
import PortfolioAnalytics from './portfolioAnalytics';
import RevenueAnalytics from './revenueAnalytics';


const routerList = [
    // {
    //     name: 'Mutual Fund Research',
    //     path: "mutual-fund-research",
    //     component: MutualFundResearch,
    // },
    {
        name: 'Portfolio Analytics',
        path: "portfolio-analytics",
        component: PortfolioAnalytics,
    },
    // {
    //     name: 'Revenue Analytics',
    //     path: "revenue-analytics",
    //     component: RevenueAnalytics,
    // },
]

function AnalyticsRoutes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => (
                    <Route
                        exact
                        key={index}
                        path={`${path}/${item.path}`}
                        component={item.component}
                    />
                ))
            }
        </Switch>
    );
}
export default function AnalyticsRouter(): JSX.Element {
    return (
        <>

            <CommonLayout>
                <AnalyticsRoutes />
            </CommonLayout>


        </>
    )
}